export default (args) => ({

    init() {
        console.log('ARGS', args);
    },

    handleSubmit(event) {
        // pass through the entire submission
        this.$dispatch('checkout-form-submit');

        // submit the form via ajax
        const form = event.target;
        const formData = new URLSearchParams(new FormData(form));

        fetch('/', {
            method: 'POST',
            body: formData,
            headers: {
                'Accept': 'application/json',
            },
            credentials: 'same-origin',
        }).then(response => response.json())
        .then(data => {
            this.$dispatch('checkout-form-success', data);

            // make sure redirect has slash at the front
            const redirect = data.redirect.startsWith('/') ? data.redirect : `/${data.redirect}`;

            window.location.href = redirect;
        });
    }
})
